import type { PublicationCode } from '@/scopes/common/domain/models'
import { trustIconsForEWHbe, trustIconsForEWHnl } from './trustIcons'

export function getTrustIcons(publicationCode: PublicationCode) {
  const TRUST_ICONS: Partial<Record<PublicationCode, Record<string, string>[]>> = {
    BE: trustIconsForEWHbe,
    EZ: trustIconsForEWHnl,
  }

  const trustIcons = TRUST_ICONS[publicationCode] ?? []

  return trustIcons
}

export function getRyanairPreviousStepUrl(publicationCode: PublicationCode): string | undefined {
  const RYANAIR_PREVIOUS_STEP_URLS: Partial<Record<PublicationCode, string>> = {
    SZ: '/vakantie/bookingpage/boeking-stap-3',
    WG: '/wintersport/bookingpage/stap3',
    KZ: '/rejser/booking/trin3',
    KW: '/skiferie/booking/trin-3',
    FZ: '/vacances/bookingpage/etape3-coordonnees',
    FW: '/ski/bookingpage/etape-3-coordonnees',
    QZ: '/solresor/bokning/steg-3',
    QW: '/skidresor/bookingpage/steg-3',
    BZ: '/nl/vakantie/bookingpage/stap-3',
    BW: '/nl/skivakantie/bookingpage/stap-3',
    FS: '/fr/vacances/bookingpage/etape-3',
    FH: '/fr/ski/bookingpage/etape-3',
    UW: '/ski/booking/step-3',
    DW: '/skiurlaub/buchung/schritt-3',
    EZ: '/bookingpage/boeking-stap-3-jouw-gegevens',
    BE: '/bookingpage/boeking-stap-3-jouw-gegevens',
  }

  return RYANAIR_PREVIOUS_STEP_URLS[publicationCode]
}

export function shouldShowConfirmationPopupOnPersonalDetailsStep(publicationCode: PublicationCode) {
  const skipConfirmationPopupForPublicationCodes: PublicationCode[] = ['UW', 'FZ', 'FW']

  return !skipConfirmationPopupForPublicationCodes.includes(publicationCode)
}
